<template>
  <div v-if="isDevelopment" class="dev-warning">
    Development Mode: All emails will be sent to {{ devEmail }}
  </div>
</template>

<script>
export default {
  name: 'DevelopmentWarning',
  data() {
    return {
      isDevelopment: process.env.NODE_ENV === 'development',
      devEmail: process.env.VUE_APP_DEV_EMAIL
    }
  }
}
</script>

<style scoped>
.dev-warning {
  background-color: #fed7d7;
  color: #c53030;
  padding: 8px 16px;
  margin-bottom: 16px;
  border-radius: 4px;
  font-size: 0.875rem;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}
</style> 